import 'babel-polyfill'
import {AUTH} from '@/store/types'
import router from '@/router'
import security from '@/security'
import utils from '@/utils/utils'
import Vue from "vue";
const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    hostnameAdmin: [
      'admin.neowrk.com',
      // 'localhost' // Uncomment this line to access admin mode on local run
    ]
  },
  getters: {
    user (state) {
      return state.user
    },
    userId (state) {
      return state.user && state.user.profile ? state.user.profile.id : ''
    },
    userEmail (state) {
      let email = state?.user?.profile?.email

      if (email && Array.isArray(email)) {
        return email[0]
      }

      return email ? email : ''
    },
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    userName (state) {
      return state.user && state.user.profile ? state.user.profile.name : ''
    },
    role (state) {
      let roles = state.user && state.user.profile ? state.user.profile.role : ''
      let rolesList = []
      if (Array.isArray(roles)) {
        rolesList = roles
      } else {
        rolesList.push(roles)
      }
      return rolesList
    },
    isAdmin (state, getters) {
      return getters.role && getters.role.some( role => role === proto.$rolesDesk4me.roles.global.client || role === proto.$rolesDesk4me.roles.support.globalAdmin)
    },
    isGlobalAdmin (state, getters) {
      return getters.role && getters.role.some( role => role === proto.$rolesDesk4me.roles.support.globalAdmin)

    },
    isTeamManager (state, getters) {
      return getters.role && getters.role.some( role => role === proto.$rolesDesk4me.roles.global.teamManager)
    },
    isGlobalAdminHostname (state) {
      var hostname = window.location.hostname
      for (var i in state.hostnameAdmin) {
        if (hostname. includes(state.hostnameAdmin[i])) {
          return true
        }
      }
      return false
    },
  },
  mutations: {
    [AUTH.SET_USER] (state, value) {
      state.user = value
    },
    [AUTH.SET_AUTHENTICATED] (state, value) {
      state.isAuthenticated = value
    }
  },
  actions: {
    signIn () {
      security.signinRedirect()
    },
    async signinCallback () {
      await security.signinRedirectCallback()
      router.push('/')
    },
    async authenticate ({dispatch, getters}) {
      let user = await dispatch('getUser') // see if the user details are in local storage
      if (user) {
        if (user.expired) {
          // Se expirado efetua o login novamente
          dispatch('Global/showLoading', null, {root: true})
          dispatch('signIn')
        } else {
          dispatch('setAuthenticated', true)
          dispatch('setUser', user)
          window.gtag('config', process.env.VUE_APP_GT_TAG, {'user_id': utils.generateHashFromString(getters.userEmail)})

          // From singing or firts open, load initial settings
          if (router.history.current.name === 'SignIn' || !router.history.current.name) {
            await dispatch('loadInitialData', (await user).access_token)
          }
        }
      }
    },
    async getUser () {
      let user = await security.getUser()
      return user
    },
    async loadInitialData ({dispatch, getters, rootState}) {
      dispatch('Global/showLoading', null, {root: true})
      if (!getters.isGlobalAdminHostname) {
        await dispatch('Global/updateInitialSettings', null, {root: true})
        dispatch('Client/setClientId', rootState.Global.initialSettings.workspaceId, {root: true})
      }
    },
    signout () {
      security.signoutRedirect()
    },
    setAuthenticated ({commit}, auth) {
      commit(AUTH.SET_AUTHENTICATED, auth)
    },
    setUser ({commit}, user) {
      commit(AUTH.SET_USER, user)
    }
  }
}
